var classes = {"splashLogo":"SplashLogo-module_splashLogo__hedfy","logoSubtitle":"SplashLogo-module_logoSubtitle__73r36","logoBlack":"SplashLogo-module_logoBlack__o0PHl"};

export { classes as default };
